// extracted by mini-css-extract-plugin
module.exports = {"subPageContainer":"ContentfulSubPage-module--subPageContainer--1ix5d"};